module.exports = __webpack_public_path__ + "img/180.5b96bf57.png";